import lite from "../../assets/icons/pro/lite.png";
import plus from "../../assets/icons/pro/plus.png";
import alpha from "../../assets/icons/pro/alpha.png";
import supe from "../../assets/icons/pro/super.png";
import vector from "../../assets/Images/Vector.png";
import greenTickIcon from "../../assets/Images/green_tick_icon.png";
import crossTickIcon from "../../assets/Images/cross_tick.png";
import Image from "next/image";
import { cn } from "@/lib/utils";
import Link from "next/link";

export default function BenefitsSection({ className = "" }) {
    return (
        <Link href="/pro">
            <div
                className={cn(
                    "w-full font-Inter flex flex-col justify-center items-start gap-4 border border-[#747474] p-2 rounded-xl border-solid bg-[#363636] max-w-screen-md mx-auto",
                    className
                )}
            >
                <div className="flex justify-between items-center gap-3 self-stretch px-3 py-2 rounded-lg bg-[#202020] ">
                    <div className=" text-white text-sm md:text-2xl not-italic font-medium leading-6">Benefits</div>
                    <div className="flex flex-row gap-2">
                        <Image className="w-8 md:w-12" src={lite} alt="demo image" />
                        <Image className="w-8 md:w-12" src={plus} alt="demo image" />
                        <Image className="w-8 md:w-12" src={alpha} alt="demo image" />
                        <Image className="w-8 md:w-12" src={supe} alt="demo image" />
                    </div>
                </div>

                <div className="flex flex-col items-start gap-2 self-stretch ">
                    <div className="flex items-center justify-between self-stretch p-2 rounded-lg bg-[#202020]">
                        <div className="flex flex-row gap-2">
                            <Image className="w-4 object-contain" src={vector} alt="demo image" />
                            <p className="text-[#F5F5F5] text-center text-xs md:text-lg font-semibold">
                                Premium screeners
                            </p>
                        </div>
                        <div className="flex flex-row gap-7 md:gap-10 px-3 md:px-5">
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                        </div>
                    </div>

                    <div className="flex items-center justify-between self-stretch p-2 rounded-lg bg-[#202020]">
                        <div className="flex flex-row gap-2">
                            <Image className="w-4 object-contain" src={vector} alt="demo image" />
                            <p className="text-[#F5F5F5] text-center text-xs md:text-lg font-semibold">Equity trades</p>
                        </div>
                        <div className="flex flex-row gap-7 md:gap-10 px-3 md:px-5">
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                        </div>
                    </div>

                    <div className="flex items-center justify-between self-stretch p-2 rounded-lg bg-[#202020] border-[0.5px] border-[#C6A4EF]">
                        <div className="flex flex-row gap-2">
                            <Image className="w-4 object-contain" src={vector} alt="demo image" />
                            <p className="text-[#F5F5F5] text-center text-xs md:text-lg font-semibold">
                                Futures trades
                            </p>
                        </div>
                        <div className="flex flex-row gap-7 md:gap-10 px-3 md:px-5">
                            <Image className="w-3 md:w-4" src={crossTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={crossTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                        </div>
                    </div>

                    <div className="flex items-center justify-between self-stretch p-2 rounded-lg bg-[#202020]">
                        <div className="flex flex-row gap-2">
                            <Image className="w-4 object-contain" src={vector} alt="demo image" />
                            <p className="text-[#F5F5F5] text-center text-xs md:text-lg font-semibold">
                                Options trades
                            </p>
                        </div>
                        <div className="flex flex-row gap-7 md:gap-10 px-3 md:px-5">
                            <Image className="w-3 md:w-4" src={crossTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={crossTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                            <Image className="w-3 md:w-4" src={greenTickIcon} alt="demo image" />
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
}
